import React from 'react';

import { PortalEnvironment } from './environments';
import { TEACHER_NAV } from './teacher-nav';
import './teacher.generated.css';

/**
 * The educator portal, as configuration.
 *
 * The stylesheet is imported here rather than in the shell so an environment
 * brings its own palette: the shell imports only the shared core, and adding
 * the family portal cannot pull violet into it.
 */
export const TEACHER_ENVIRONMENT: PortalEnvironment = {
  scope: 'env-teacher',
  chrome: 'portal',
  navLabelClass: 'nlabel',
  badge: 'Educator Portal',
  home: '/teacher/dashboard',
  cta: { label: 'Create course', to: '/teacher/courses/new' },
  nav: TEACHER_NAV,
  shortcut: {
    to: '/teacher/calendar',
    title: 'Schedule',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  accountLinks: [
    { label: 'Profile & settings', to: '/profile' },
    { label: 'Settings', to: '/settings' },
    { label: 'Payout settings', to: '/teacher/earnings' },
    { label: 'Help centre', to: '/help' },
  ],
};
